import EventBus from '@/js/util/EventBus'

export default {
  props: {
    videoSrc: {
      type: String,
      required: true,
    },
    videoId: {
      type: Number,
      required: true,
    },
    options: {
      type: Object,
      default: () => ({}),
    },
    domProps: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      isPlaying: true,
    }
  },

  watch: {
    isPlaying: 'handleIsPlaying',
  },

  created() {
    EventBus.$on('toggle', this.maybeToggle)
  },

  methods: {
    maybeToggle(id) {
      if (this.videoId !== id) {
        return
      }
      this.isPlaying = !this.isPlaying
    },

    handleIsPlaying() {
      const { isPlaying, $el } = this
      const player = {
        default: !isPlaying ? $el.play() : $el.pause(),
        autoplay: !isPlaying ? $el.pause() : $el.play(),
      }
      return !$el.autoplay ? player.default : player.autoplay
    },

  },

  render(createElement) {
    const domProps = Object.assign({
      muted: true,
    }, this.domProps)
    const attrs = Object.assign(
      {
        loop: true,
        autoplay: true,
        playsinline: '',
        src: this.videoSrc,
        'aria-hidden': true,
      },
      this.options,
    )
    return createElement('video', { domProps, attrs })
  },
}




// WEBPACK FOOTER //
// ./src/js/components/SilentVideoContent.js